
<template>
  <div id="app">
    <img alt="the dm" class="logo" src="./assets/thedm.jpg">
    <div class="bios fb">
      <div class="profile">
        
          <img class="pic" src="./assets/audrey.jpg">
          <p>
            AUDREY BRIANNE IS AN LA-BASED WARDROBE STYLIST. HER 
            CLIENTELE INCLUDES A WHO'S-WHO OF CAPTIATING TALENT
            INCLUDING A WIDE-RANGE OF 'YOUNG HOLLYWOOD,' TV & FILM
            ACTORS AND MUSICIANS.<br/><br/>

            FOR OVER A DECADE, AUDREY HAS BEEN STYLING WITH AN EMPHASIS
            ON CELEB RED CARPET APPEARANCES AND EDITORIAL.<br/><br/>

            SHE HAS BEEN A RECURRING CELEB STYLIST CONTRIBUTOR ON TMZ'S 
            TOOFAB AND IS CURRENTLY A CONTRIBUTING WRITER FOR RIVAL 
            MAGAZINE AND MENTAL HEALTH AWARENESS INCENTIVE 'CHECK IN
            WITH YOU'.<br/><br/>
            AUDREYBRIANNE.COM 
          </p>
        </div>
        
      
      <div class='vert'></div>
      <div class="profile">
        
          <img  class="pic" src="./assets/tyree.jpg">
          <p>
            HI MY NAME IS TYREE- OF TYREE'S STYLE!<br/><br/>
            I AM A MULTIFACETED ARTIST WITH A BACKGROUND IN STYLING,
            MERCHANDISING, MARKETING AND PUBLIC RELATIONS. I HAVE 10+
            YEARS OF EXPERIENCE IN THE FASHION INDUSTRY AND UNDERSTAND
            THE NEEDS OF VARIOUS CLIENTELE FROM LUXURY TO AN INTERNATIONAL
            AUDIENCE.<br/><br/>

            TYREE'S STYLE IS NOT JUST ABOUT MY STYLE, BUT YOURS TOO!
            HERE I WILL SHAE MY STYLE TIPS AND TRICKS AS WELL AS OTHER
              VENTURES TO ENHANCE OUR STYLE COLLECTIVELY.<br/><br/>

            WELCOME TO TYREE'S STYLE.<br/><br/>

            TYREESSTYLE.COM
          </p>
      </div>
    </div>
      
     <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <!-- <router-view/> -->

      <!-- <Podcasts v-bind:podcasts="podcasts" /> -->
  </div>
</template>

<script>
import axios from 'axios'
// import Podcasts from './components/Podcasts'
export default {
  name: 'App',
  components: {
    // Podcasts
  },
  data(){
    return {
      podcasts: ['ep1','ep2']
    }
  },
  created(){
    axios.get('https://jsonplaceholder.typicode.com/todos?_limit=4').then(data=>{
      this.podcasts = data.data;
    })
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 10px;
  box-sizing: border-box;
}
#app {
  font: 8pt 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.bios p{
  text-align: left;
  line-height: 1.5
}
.fb{
  display: flex;
  justify-content: center;

}

.profile{
  flex-grow: 1;
  width: 50%;
  padding: 0 60px;
  line-height: 4
}
.profile p{
  max-width: 340px;
  margin: 0 auto;
}
/* .fb div:nth-child(even){
  
  flex-grow: unset;
} */
.vert{
  background-color: #000;
  width: 1px;
  margin: 0;
  padding: 0;
}
.pic{
  border-radius: 20px
}

@media only screen and (max-width: 800px) {

.fb{
  flex-direction: column
}
.profile{
  width: 100%;
}
.vert{
  height: 1px;
  width: 100%;
  margin: 40px 0;
}
}
</style>
